<div class="container">
    <div class="d-flex flex-column justify-content-center align-items-center">
        <img alt="" class="mw-100" src="/assets/img/maintenance.svg" />
        <h1>{{ 'ADMIN_PROFI.MAINTENANCE.TITLE.' + type | translate }}</h1>
        <p [innerHTML]="'ADMIN_PROFI.MAINTENANCE.DESCRIPTION.' + type | translate" class="text-center"></p>
        <a color="primary" href="" mat-raised-button>{{ 'ADMIN_PROFI.MAINTENANCE.BUTTON.TEXT' | translate }}</a>
    </div>
</div>
